const BLOG_LANGUAGE_TAGS: Record<string, string> = {
    pt: 'pt-BR',
    zh: 'zh-Hans',
};

const REGIONAL_YOUTUBE_HREFLANG_PARENTS = new Set([
    'youtube-promotion-services-guide',
    'buy-youtube-views',
    'paid-youtube-views-monetization',
]);

export const getBlogLanguageTag = (lang?: string, parentSlug?: string): string => {
    const normalized = lang || 'en';
    if (normalized === 'es' && parentSlug && REGIONAL_YOUTUBE_HREFLANG_PARENTS.has(parentSlug)) {
        return 'es-419';
    }
    return BLOG_LANGUAGE_TAGS[normalized] || normalized;
};
